import { render, staticRenderFns } from "./MagHistoryTile.vue?vue&type=template&id=655ab63c"
import script from "./MagHistoryTile.vue?vue&type=script&lang=js"
export * from "./MagHistoryTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports